const SET_NOTIFICATION = 'SET_NOTIFICATION';
const SET_NOTIFICATION_REFACTORED = 'SET_NOTIFICATION_REFACTORED';

export { SET_NOTIFICATION, SET_NOTIFICATION_REFACTORED };
